module.exports = __webpack_public_path__ + "img/Logo-ICFA-strapi.6274ce4.png";